import React from 'react'
import { useI18n } from 'i18n'

const TONES = {
  green: { bg: 'bg-green-50 border-green-200', text: 'text-status-ready', dot: 'bg-status-ready' },
  orange: { bg: 'bg-orange-50 border-orange-200', text: 'text-status-review', dot: 'bg-orange-500' },
  red: { bg: 'bg-red-50 border-red-200', text: 'text-status-incomplete', dot: 'bg-status-incomplete' },
  slate: { bg: 'bg-slate-50 border-slate-200', text: 'text-slate-500', dot: 'bg-slate-300' },
  sky: { bg: 'bg-sky-50 border-sky-200', text: 'text-sky-600', dot: 'bg-sky-500' }
}

// Shipment, document and cost-line statuses share one badge; labels via i18n (`status.*`).
const STATUS_TONE = {
  draft: 'slate',
  review: 'orange',
  calculated: 'green',
  closed: 'sky',
  processing: 'slate',
  ready: 'green',
  failed: 'red',
  suggested: 'orange',
  confirmed: 'green',
  rejected: 'red',
  duplicate: 'slate'
}

const StatusBadge = ({ status }) => {
  const { t } = useI18n()
  const s = TONES[STATUS_TONE[status] || 'slate']
  return (
    <span className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-3 py-1 text-xs font-semibold ${s.bg} ${s.text}`}>
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />
      {STATUS_TONE[status] ? t(`status.${status}`) : (status || '—')}
    </span>
  )
}

export default StatusBadge
